import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FilterMessagesUserPopoverIcon = (props: IconProps) => (
  <Icon height="16px" width="16px" viewBox="0 0 16 16" {...props}>
    <path d="M11.6 3.82H3.067C2.48 3.82 2 4.284 2 4.85v8.97l2.133-2.059H11.6c.587 0 1.067-.463 1.067-1.029V4.85c0-.566-.48-1.03-1.067-1.03Zm0 6.912H4.133l-1.066 1.03V4.85H11.6v5.882Z" />
    <path
      fillRule="evenodd"
      d="M14.5 5.986v5.834c0 1.012-.82 1.833-1.833 1.833H5.5v-1h7.167c.46 0 .833-.373.833-.833V5.986h1ZM10.667 7.154H4v-1h6.667v1Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.667 9.154H4v-1h6.667v1Z"
      clipRule="evenodd"
    />
  </Icon>
);

export default memo(FilterMessagesUserPopoverIcon);
